/* tslint:disable */
export enum PlayState {
  PROMOTED = 'PROMOTED',
  PUBLISHED = 'PUBLISHED',
}
